export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.d932cd76e172cfbfc60151aeb3db2b1f.css";